<script setup>
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { getRouteName } from '@/views/algorithm-detail/utils.js'
const { t } = useI18n()

//路由
const route = useRoute()
const routeName = getRouteName(route)

defineProps({
  source: String,
  canUpload: {
    type: Boolean,
    default: true,
  },
})
</script>

<template>
  <div class="tips">
    <span v-if="routeName === 'Landmarks'">
      *请上传一张本地图片即刻体验——指尖轻触即启在线秒级捕捉眉梢颤动、嘴角弧度等22+微表情单元
    </span>
    <span v-else-if="routeName === 'faceEmotion'">
      *请上传一张本地图片即刻体验——构建多维度情绪图谱，从喜到惧、从平静到激昂，让机器读懂情绪语言
    </span>
    <span v-else-if="routeName === 'faceAppearanceLevel'">
      *生成0-100分智能评分及可视化报告，同步输出妆容/发型优化建议，让颜值进化有据可依
    </span>
    <span v-else-if="routeName === 'bodyGestureRecognition'">
      *请上传一张本地图片即刻体验——捕捉指尖轨迹、掌纹脉络与关节屈伸角度，精准解码静态手势（比心/OK/数字）、动态组合（缩放/旋转/挥手）及复杂语义（如“暂停”“确认”）
    </span>
    <span v-else-if="routeName === 'bodyKeypoint'">
      *请上传一张本地图片，体验功能——当前页面预览核心骨骼连线与关键节点标注，使用SDK可解锁全维度数据（含关节活动度曲线、动作连贯性评分），无论是健身纠错、舞蹈复刻还是康复评估，都能让无形的体态跃然成可触摸的数字骨架
    </span>
    <span v-else-if="routeName === 'bodyDetection'">
      *请上传一张本地图片，体验功能——实现从单人自拍到群体合影的稳定识别。当前页面最多显示10个检测结果，使用SDK可获取全部检测框及置信度信息，为安防布控、客流统计、运动分析等场景提供可靠的“人在哪里”的第一层感知。
    </span>
    <span v-else-if="canUpload">
      {{ $t('homepage.uploadTip') }}
    </span>
    <span class="tips2" v-if="source === 'face' && canUpload"
      >({{ t('home.face_tips') }})</span
    >
  </div>

  <div class="tips-2">
    <span v-if="routeName === 'ocrWaterMeter'">
      *以上为云端算法模型推理的结果展示，针对您所在行业的具体场景，我们将通过专项的精细化定制，精准匹配您的实际需求。
    </span>
    <span v-else>
      *以上为算法的基础演示，针对您所在行业的具体场景，我们将通过专项的精细化定制，精准匹配您的实际需求。
    </span>
  </div>
</template>

<style lang="scss" scoped>
.tips {
  margin-top: 24px;
  color: #666;
}

.tips-2 {
  color: #666;
}

.tips2 {
  font-size: 12px;
}
</style>
